import React, { Fragment, useEffect, useRef } from "react";
import { any, func, bool } from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import FormCreator from "../../common/FormCreator";
import {
  formCreatorConvertToValues,
  useForm,
} from "../../common/FormCreator/helpers";
import history from "../../history";
import { submitPecanAssessment } from "../../redux/actions/pecanActions";

const PecanAssessment = ({
  appData,
  submitPecanAssessmentFunc,
  pecanAssessmentLoading,
}) => {
  const isEmpty = (val) => typeof val === "undefined" || val === null;
  // const [loading, setLoading] = useState(false);
  const getField = (data) => (fieldName) =>
    !isEmpty(data[fieldName]) ? data[fieldName] : "";

  const scrollToResults = useRef(null);

  useEffect(() => {
    scrollToResults.current.scrollIntoView({ behavior: "smooth" });
  }, [appData.pecanOnboarding]);

  let total;

  if (
    appData.pecanOnboarding &&
    appData.pecanOnboarding.forms &&
    appData.pecanOnboarding.forms.assessment &&
    !pecanAssessmentLoading
  ) {
    total =
      appData.pecanOnboarding &&
      appData.pecanOnboarding.forms &&
      appData.pecanOnboarding.forms.assessment &&
      appData.pecanOnboarding.forms.assessment.total;
  }

  const getVal = getField({});
  const initialState = {
    section1: {
      htmlObj: (
        <div>
          <p>Please complete the assessment questionnaire.</p>
          <p>
            Please select the correct answers or write a short answer if
            required.
          </p>
        </div>
      ),
    },
    Group30: {
      title:
        "1. What two food items are not permitted anywhere on Company premises?",
      value: getVal("Group30"),
      type: "multivalueCheckbox",
      selectOptions: [
        { label: "Chocolate", value: "Chocolate" },
        {
          label: "Peanuts or anything containing peanuts",
          value: "Peanuts or anything containing peanuts",
        },
        { label: "Fruit", value: "Fruit" },
        { label: "Fizzy Drinks", value: "Fizzy Drinks" },
        { label: "Chewing Gum", value: "Chewing Gum" },
      ],
      mandatory: true,
    },
    Group31: {
      title:
        "2. What Jewellery are you permitted to wear in the production areas? (please select only one answer)",
      value: getVal("Group31"),
      type: "multivalueCheckbox",
      selectOptions: [
        { label: "Watch", value: "Watch" },
        {
          label: "Engagement ring with precious stones in it",
          value: "Engagement ring with precious stones in it",
        },
        { label: "Necklace or Neck Chain", value: "Necklace or Neck Chain" },
        { label: "Earrings", value: "Earrings" },
        { label: "Plain Wedding Band", value: "Plain Wedding Band" },
      ],
      mandatory: true,
    },
    Group32: {
      title:
        "3. Which part of your body is most likely to be injured if you lift a heavy load? (please select only one answer)",
      value: getVal("Group32"),
      type: "multivalueCheckbox",
      selectOptions: [
        { label: "Knees", value: "Knees" },
        { label: "Back", value: "Back" },
        { label: "Feet", value: "Feet" },
        { label: "Shoulders", value: "Shoulders" },
      ],
      mandatory: true,
    },
    Group33: {
      title:
        "4. SIGN031 displayed around site, how long does it say you are meant to wash your hands for it to be done correctly to wash away any pathogens or bacteria? (please select only one answer)",
      value: getVal("Group33"),
      type: "multivalueCheckbox",
      selectOptions: [
        { label: "40-60 Seconds", value: "40-60 Seconds" },
        { label: "10-20 Seconds", value: "10-20 Seconds" },
        { label: "5-10 Seconds", value: "5-10 Seconds" },
        { label: "30-40 Seconds", value: "30-40 Seconds" },
        { label: "50-60 Seconds", value: "50-60 Seconds" },
      ],
      mandatory: true,
    },
    Group34: {
      title:
        "5. What colour Mob Cap do First Aiders Wear? (please select only one answer)",
      value: getVal("Group34"),
      type: "multivalueCheckbox",
      selectOptions: [
        { label: "Blue", value: "Blue" },
        { label: "Red", value: "Red" },
        { label: "White", value: "White" },
        { label: "Green", value: "Green" },
        { label: "Orange", value: "Orange" },
      ],
      mandatory: true,
    },
    Group35: {
      title:
        "6. You need to lift a load from the floor. You should stand with your: (please select only one answer)",
      value: getVal("Group35"),
      type: "multivalueCheckbox",
      selectOptions: [
        {
          label: "Feet wide apart, legs straight",
          value: "Feet wide apart, legs straight",
        },
        {
          label: "Feet together, legs straight",
          value: "Feet together, legs straight",
        },
        {
          label: "Feet together, knees bent",
          value: "Feet together, knees bent",
        },
        {
          label: "Feet slightly apart, knees bent",
          value: "Feet slightly apart, knees bent",
        },
      ],
      mandatory: true,
    },
    Group36: {
      title:
        "7. You are permitted to consume food/drink in the production areas. Is this statement - True (select Yes) or False (select No)?",
      value: getVal("Group36"),
      type: "checkbox",
      mandatory: true,
    },
    Group37: {
      title: "8. What are 3 pests that could be found on site?",
      value: getVal("Group37"),
      type: "multivalueCheckbox",
      selectOptions: [
        { label: "Worms", value: "Worms" },
        { label: "Ants", value: "Ants" },
        { label: "Deer", value: "Deer" },
        { label: "Wasps", value: "Wasps" },
        { label: "Mice", value: "Mice" },
      ],
      mandatory: true,
    },
    Group38: {
      title:
        "9. What should you do if you see a food pest in site buildings? (please select only one answer)",
      value: getVal("Group38"),
      type: "multivalueCheckbox",
      selectOptions: [
        {
          label: "Try and remove them yourself",
          value: "Try and remove them yourself",
        },
        { label: "Nothing", value: "Nothing" },
        {
          label: "Report any sightings to your Line Manager",
          value: "Report any sightings to your Line Manager",
        },
        { label: "Stand on them", value: "Stand on them" },
      ],
      mandatory: true,
    },
    Group39: {
      title:
        "10. What are signs of Pest Activity? (write a short answer in box provided)",
      value: getVal("Group39"),
      type: "textarea",
      mandatory: true,
    },
    Group40: {
      title:
        "11. If you have to twist or turn your body when your lift and place a load it means: (please select only one answer)",
      value: getVal("Group40"),
      type: "multivalueCheckbox",
      selectOptions: [
        {
          value: "The weight you can lift safely is less than usual",
          label: "The weight you can lift safely is less than usual",
        },
        {
          value: "The weight you can safely lift is more than usual",
          label: "The weight you can safely lift is more than usual",
        },
        {
          value: "You must wear a neck brace",
          label: "You must wear a neck brace",
        },
        {
          value: "Nothing, you can lift the same weight as usual",
          label: "Nothing, you can lift the same weight as usual",
        },
      ],
      mandatory: true,
    },
    Group41: {
      title: "12. What does GMP stand for? (please select only one answer)",
      value: getVal("Group41"),
      type: "multivalueCheckbox",
      selectOptions: [
        { value: "Good Making Plan", label: "Good Making Plan" },
        {
          value: "Good Manufacturing Practice",
          label: "Good Manufacturing Practice",
        },
        { value: "Good Meal Plan", label: "Good Meal Plan" },
      ],
      mandatory: true,
    },
    Group42: {
      title:
        "13. A Food allergy is an adverse reaction to a particular food that involves the immune system, please select two allergens we use in the production of our products?",
      value: getVal("Group42"),
      type: "multivalueCheckbox",
      selectOptions: [
        { label: "Sesame", value: "Sesame" },
        { label: "Egg", value: "Egg" },
        { label: "Fish", value: "Fish" },
        { label: "Celery", value: "Celery" },
        { label: "Milk", value: "Milk" },
      ],
      mandatory: true,
    },
    Group43: {
      title:
        "14. To lift a load safely you need to think about: (please select only one answer)",
      value: getVal("Group43"),
      type: "multivalueCheckbox",
      selectOptions: [
        { value: "How heavy it is", label: "How heavy it is" },
        { value: "It's size and condition", label: "It's size and condition" },
        { value: "All the other answers", label: "All the other answers" },
        { value: "If it has handhold", label: "If it has handhold" },
      ],
      mandatory: true,
    },
    Group44: {
      title:
        "15. The Company is HALAL approved, what are the two main foods forbidden by Muslim dietary requirements? ",
      value: getVal("Group44"),
      type: "multivalueCheckbox",
      selectOptions: [
        { label: "Beef", value: "Beef" },
        { label: "Alcohol", value: "Alcohol" },
        { label: "Chocolate", value: "Chocolate" },
        { label: "Coffee", value: "Coffee" },
        { label: "Pork", value: "Pork" },
      ],
      mandatory: true,
    },
    Group45: {
      title:
        "16. In the event of witnessing or being involved in accident or near miss, what should you do? (please select only one answer)",
      value: getVal("Group45"),
      type: "multivalueCheckbox",
      selectOptions: [
        {
          value: "Nothing carry on working",
          label: "Nothing carry on working",
        },
        {
          value: "Tell your colleagues when on your break",
          label: "Tell your colleagues when on your break",
        },
        {
          value:
            "Report it to your line manager for recording in an accident book or near miss report",
          label:
            "Report it to your line manager for recording in an accident book or near miss report",
        },
      ],
      mandatory: true,
    },
    Group46: {
      title:
        "17. In the event of you becoming ill whilst working on site, what should you do? (please select only one answer)",
      value: getVal("Group46"),
      type: "multivalueCheckbox",
      selectOptions: [
        {
          value: "Nothing carry on working",
          label: "Nothing carry on working",
        },
        {
          value: "Tell your line manager you are ill and may need to go home",
          label: "Tell your line manager you are ill and may need to go home",
        },
        { value: "Tell your colleague", label: "Tell your colleague" },
      ],
      mandatory: true,
    },
    Group47: {
      title:
        "18. If you have sickness and/or diarrhoea, how long do you have to be clear of symptom's before returning to work? (please select only one answer)",
      value: getVal("Group47"),
      type: "multivalueCheckbox",
      selectOptions: [
        { value: "36 hours", label: "36 hours" },
        { value: "24 hours", label: "24 hours" },
        { value: "48 hours", label: "48 hours" },
      ],
      mandatory: true,
    },
    Group48: {
      title:
        "19. Upon your return to work from absence or overseas travel, what document needs to be completed? (please select only one answer)",
      value: getVal("Group48"),
      type: "multivalueCheckbox",
      selectOptions: [
        { value: "Return to Work Form", label: "Return to Work Form" },
        { value: "Holiday Form", label: "Holiday Form" },
        { value: "Accident Form", label: "Accident Form" },
      ],
      mandatory: true,
    },
    Group49: {
      title:
        "20. Where are the only areas smoking or vaping are permitted on site or at Lincoln House? (please select only one answer)",
      value: getVal("Group49"),
      type: "multivalueCheckbox",
      selectOptions: [
        { value: "Near your car", label: "Near your car" },
        {
          value: "Outside the fence or gates",
          label: "Outside the fence or gates",
        },
        {
          value: "At designated smoking shelters",
          label: "At designated smoking shelters",
        },
      ],
      mandatory: true,
    },
  };

  const [fields, setField] = useForm(initialState);

  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);
    const fieldsWithNoFalseValues = Object.keys(fieldValuesPayload).reduce(
      (acc, key) => {
        if (key === "Group39" || key === "Group36") {
          return { ...acc, [key]: fieldValuesPayload[key] };
        }
        const answer = {};
        Object.keys(fieldValuesPayload[key]).forEach((insideKey) => {
          if (fieldValuesPayload[key][insideKey]) {
            answer[insideKey] = true;
          }
        });

        return { ...acc, [key]: answer };
      },
      {}
    );

    submitPecanAssessmentFunc({
      ...fieldsWithNoFalseValues,
    });
  };

  return (
    <div ref={scrollToResults}>
      {appData.pecanOnboarding &&
      appData.pecanOnboarding.forms &&
      appData.pecanOnboarding.forms.submittedAssessment ? (
        <Fragment>
          <div className="container d-flex flex-column align-items-center justify-content-center pt-4 pb-2">
            <h2 style={{ padding: "0 3rem" }}>
              Assessment Questionnaire Results
            </h2>
            <div
              style={{
                fontSize: "30px",
                padding: "2rem",
                display: "flex",
                flexDirection: "column",
                textAlign: "center",
              }}
            >
              <p>
                SCORE: <b style={{ fontWeight: "700" }}>{total}</b>
              </p>
              {total < 15 ? (
                <Fragment>
                  <p>
                    STATUS:{" "}
                    <b style={{ color: "red", fontWeight: "700" }}>FAILED</b>
                  </p>
                  <p
                    style={{
                      fontSize: "25px",
                      padding: "3rem",
                      fontWeight: "600",
                    }}
                  >
                    Please contact your HRGO consultant for next steps.
                  </p>
                </Fragment>
              ) : (
                <Fragment>
                  <p>
                    STATUS:{" "}
                    <b style={{ color: "green", fontWeight: "700" }}>PASSED</b>
                  </p>
                  <p
                    style={{
                      fontSize: "25px",
                      padding: "3rem",
                      fontWeight: "600",
                    }}
                  >
                    Well done on passing the assessment. <br />
                    Your HRGO consultant will be in touch with the next steps.
                  </p>
                </Fragment>
              )}
            </div>
          </div>
          <div
            className="container"
            style={{
              display: "flex",
              justifyContent: "flex-end",
              padding: "0 2rem 6rem 0",
            }}
          >
            <Link
              to="/profile/edit/onboarding-pecan"
              className="btn btn-outline-dark text-dark hover-text-white"
            >
              Go Back
            </Link>
          </div>
        </Fragment>
      ) : (
        <FormCreator
          formTitle={"Assessment Questionnaire"}
          fields={fields}
          loading={pecanAssessmentLoading}
          setField={setField}
          handleSubmit={handleSubmit}
          handleCancel={() => history.push("/profile/edit/onboarding-pecan")}
          onboardingBranch={"pecan"}
          helper=""
        />
      )}
    </div>
  );
};

PecanAssessment.propTypes = {
  submitPecanAssessmentFunc: func,
  appData: any,
  submitPecanFormsFunc: func,
  pecanAssessmentLoading: bool,
};
const mapDispatchToProps = {
  submitPecanAssessmentFunc: submitPecanAssessment,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
  pecanAssessmentLoading: state.core.pecanAssessment.isLoading,
});
const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(PecanAssessment);
